import * as React from 'react';

function SvgPropertyHome(props) {
  return (
    <svg width={14} height={14} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        clipRule="evenodd"
        d="M.299 5.462L6.328.246C6.512.088 6.75 0 7.002 0c.25 0 .49.088.672.247L12.4 4.214a.453.453 0 00.092.202l1.209 1.046c.396.343.298.717.259.823-.039.106-.21.453-.733.453H12.4v5.95a.97.97 0 01-.97.97H2.569a.97.97 0 01-.97-.97V6.737H.774c-.523 0-.693-.346-.733-.453-.04-.106-.137-.479.259-.822zm8.451.663h-3.5V10.5h3.5V6.125z"
      />
    </svg>
  );
}

export default SvgPropertyHome;
